import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { logIn } from "../../actions";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "../ui/Modal";
import { Field, Input } from "../ui/Field";
import { Button } from "../ui/Button";

const DEFAULT_DATA = { email: "", password: "" };

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function LogInDialog({
  openDialog,
  handleCloseDialog,
  onSubmit,
  handleClickSignUpOpt,
}) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(DEFAULT_DATA);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => setOpen(openDialog), [openDialog]);

  const close = () => {
    setOpen(false);
    handleCloseDialog(false);
  };

  const change = (key) => (e) => setData({ ...data, [key]: e.target.value });

  const submit = () => {
    dispatch(
      logIn(
        data,
        () => onSubmit(data),
        ({ response }) =>
          setSnackbar({
            open: true,
            message:
              response?.data?.msg ||
              "Oops! Something went wrong. Contact your system administrator.",
            severity: "error",
          }),
        (message) => {
          setSnackbar({
            open: true,
            message: message || "Something went wrong.",
            severity: "error",
          });
          onSubmit(null);
        }
      )
    );
  };

  const disabled = !data.email || !data.password;

  return (
    <>
      <Modal open={open} onClose={close} maxWidth="max-w-md">
        <ModalHeader
          title="Welcome back"
          subtitle="Sign in to continue your work."
          onClose={close}
        />
        <ModalBody className="space-y-4">
          <Field label="Email">
            <Input
              type="email"
              autoComplete="email"
              placeholder="you@lab.edu"
              value={data.email}
              onChange={change("email")}
            />
          </Field>
          <Field label="Password">
            <Input
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={data.password}
              onChange={change("password")}
              onKeyDown={(e) => e.key === "Enter" && !disabled && submit()}
            />
          </Field>
          <button
            type="button"
            className="text-xs text-figures-muted dark:text-brand-mutedInv hover:text-figures-ink dark:hover:text-brand-displayInv hover:underline transition"
          >
            Forgot password?
          </button>
        </ModalBody>
        <ModalFooter>
          <Button onClick={submit} disabled={disabled} className="w-full">
            Sign in
          </Button>
          <p className="text-sm text-center text-figures-muted dark:text-brand-mutedInv">
            Not a member yet?{" "}
            <button onClick={handleClickSignUpOpt} className="accent font-semibold hover:underline">
              Sign up
            </button>
          </p>
        </ModalFooter>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
